import { useState } from "react";
import { Sparkles, Loader2, ChevronDown } from "lucide-react";
import { toast } from "sonner";
import { http, formatError } from "@/lib/api";

export const AgendaItem = ({ e, i }) => {
  const [note, setNote] = useState(e.prep);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const prep = async () => {
    setBusy(true);
    try { const { data } = await http.post("/calendar/prep", { uid: e.uid }); setNote(data.note); setOpen(true); }
    catch (x) { toast.error(formatError(x)); }
    setBusy(false);
  };
  return (
    <li className="border-l border-cyan-500/30 pl-3 py-1" data-testid={`agenda-item-${i}`}>
      <div className="flex gap-3 items-baseline justify-between">
        <div className="flex gap-3 items-baseline min-w-0">
          <span className="font-mono-hud text-[11px] text-cyan-300 w-12 shrink-0">{e.start}</span>
          <span className="text-sm text-slate-200 truncate" title={e.title}>{e.title}</span>
        </div>
        {note ? (
          <button onClick={() => setOpen(!open)} className="font-mono-hud text-[10px] uppercase tracking-wider text-emerald-300 flex items-center gap-1 shrink-0" data-testid={`agenda-prep-toggle-${i}`}>
            Prep <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
          </button>
        ) : (
          <button onClick={prep} disabled={busy} className="font-mono-hud text-[10px] uppercase tracking-wider text-cyan-300 hover:text-cyan-100 flex items-center gap-1 shrink-0 transition-colors" data-testid={`agenda-prep-button-${i}`}>
            {busy ? <Loader2 size={12} className="animate-spin" /> : <Sparkles size={12} />} Prep
          </button>
        )}
      </div>
      {open && note && <p className="mt-2 text-[12px] font-mono-hud text-cyan-100/90 whitespace-pre-wrap leading-relaxed fade-up" data-testid={`agenda-prep-note-${i}`}>{note}</p>}
    </li>
  );
};
